import styled from 'styled-components'

export const ProfilePageContainer = styled.div`
  padding-top: 64px;
`

export const ProfileIconWrapper = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
`

export const ProfileIconImage = styled.div`
  height: 80px;
  width: 80px;
  background: #92bf00;
  border-radius: 50%;
  position: relative;
  text-align: center;

  > p {
    width: 100%;
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    color: white;
  }
`
export const ProfileIconStatus = styled.div`
  position: absolute;
  right: -2px;
  bottom: -2px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #fff;
  border: 2px solid white;
  box-shadow: 0 2px 8px -2px rgba(32, 32, 32, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ProfileIconNameWrapper = styled.div`
  display: block;
  margin-left: 24px;
`

export const ProfileIconName = styled.p`
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: black;
  margin-bottom: 8px;
`

export const ProfileIconRole = styled.p`
  margin-top: 0;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: rgba(32, 32, 32, 0.5);
`

export const ProfileFooter = styled.footer`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 40px;
  margin-bottom: 64px;
  font-size: 14px;
  line-height: 16px;
  text-decoration: underline;  
  color: rgba(32, 32, 32, 0.5);
  
  a{
    cursor: pointer;
  }
`
export const ChangeButton = styled.button`
  position: absolute;
  top: 46px;
  right: 8px;
  background: #ffffff;
  border: 1px solid rgba(32, 32, 32, 0.2);
  box-sizing: border-box;
  box-shadow: 0 1px 2px rgba(32, 32, 32, 0.05);
  border-radius: 4px;
  font-size: 14px;
  line-height: 16px;
  color: #202020;
  padding: 8px 16px;
  cursor: pointer;
  font-weight: 500;
  display: ${(p) => {
    return p.available ? 'block' : 'none'
  }};
`

export const PendingEmailChange = styled.button`
  position: absolute;
  top: 32px;
  right: 8px;
  background: #ffffff;
  border: 1px solid rgba(32, 32, 32, 0.2);  
  box-shadow: 0 1px 2px rgba(32, 32, 32, 0.05);
  border-radius: 4px;
  font-size: 14px;
  line-height: 16px;
  color: #202020;
  padding: 0 12px;
  display: flex;
  align-items: center;
  height: 32px;
  font-weight: 500;
`

export const YellowStatusDot = styled.span`
  height: 8px;
  width: 8px;
  background-color: #ffcb00;
  border-radius: 50%;  
  margin-right: 8px;
`

export const ModalLabelContainer = styled.div`
  padding: 24px 24px 24px 32px;
  border-bottom: 1px solid rgba(32, 32, 32, 0.1);
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
  color: #202020;
`

export const ModalContentContainer = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #202020;
`

export const PendingChangeRoleIconWrapper = styled.div`
  position: absolute;
  font-weight: 500;
  width: 94px;
  height: 32px;
  border: 1px solid rgba(32, 32, 32, 0.2);
  box-shadow:  0 1px 2px rgba(32, 32, 32, 0.05);
  border-radius: 4px;
  top: -72px;
  right: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  line-height: 16px;

  > span {
    margin-right: 8px;
  }
`
export const ApiKeysContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`

export const ApiKeyTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #202020;
  margin-bottom: 16px;
`

export const ApiKeyButton = styled.button`
  background-color: #92bf00;
  color: white;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 16px;

  &:hover {
    background-color: #86ae00;
  }
`

export const ApiKeyList = styled.div`
  margin-top: 24px;
`

export const ApiKeyItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border: 1px solid rgba(32, 32, 32, 0.1);
  border-radius: 4px;
  margin-bottom: 8px;
  background-color: white;
`

export const ApiKeyText = styled.input`
  font-size: 14px;
  color: #202020;
  border: none;
  background: transparent;
  width: 100%;
  padding: 4px;
  margin-right: 12px;
  font-weight: 500;

  &:disabled {
    color: #202020;
  }
`

export const DeleteButton = styled.button`
  background: none;
  border: none;
  color: #e63946;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;

  &:hover {
    color: #d62828;
  }
`
